
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14 9v3H2V9H0v5h16V9h-2zM4 4h3v5h2V4h3L8 0 4 4z","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#bbb"}})])
          )
        }
      }
    